import HttpService from '@/common/services/HttpService'
import { type CompanyDetailsDTOV1, type CompanyFieldConfig } from '@/common/types/company'

export const getBulkCompanies = async (ids?: number[], { expands }: CompanyFieldConfig = {}): Promise<CompanyDetailsDTOV1[]> => {
  const params = {
    expand: expands?.size ? [...expands].join() : undefined,
  }
  return HttpService.postData<CompanyDetailsDTOV1[]>('/api/v1/bulk-companies/fetch', { ids }, { params })
}
